export enum EventsVideoEvents {
  Play = 'event_video_playback_started',
  Resume = 'event_video_playback_resumed',
  Pause = 'event_video_playback_paused',
  Ended = 'event_video_playback_completed',
  Dispose = 'event_video_playback_exited',
}

export enum LibraryVideoEvents {
  Play = 'library_video_playback_started',
  Resume = 'library_video_playback_resumed',
  Pause = 'library_video_playback_paused',
  Ended = 'library_video_playback_completed',
  Dispose = 'library_video_playback_exited',
}

export enum OriginalsVideoEvents {
  Play = 'originals_video_playback_started',
  Resume = 'originals_video_playback_resumed',
  Pause = 'originals_video_playback_paused',
  Ended = 'originals_video_playback_completed',
  Dispose = 'originals_video_playback_exited',
}
